import { Box, Breadcrumbs, Typography } from "@mui/material";
import { Site } from "../../../models/SubOrganization";

interface Props {
  organization: string;
  location: string;
  subOrganizations: string;
  site?: Site;
}

export const OrganizationBreadcrumbs = (props: Props) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyItems: "center",
          marginTop: "20px",
        }}
      >
        <img src="/img/buildings-black.svg" alt="icon" />

        <Breadcrumbs
          aria-label="breadcrumb"
          sx={{
            alignSelf: "center",
            padding: "0px 20px 0px 12px",
          }}
        >
          <Typography color="var(--gray4)" variant="h3">
            {props.organization}
          </Typography>

          {props.subOrganizations !== "" ? (
            <Typography color="var(--gray4)" variant="h3">
              {props.subOrganizations}
            </Typography>
          ) : null}

          {props.site !== undefined ? (
            <Typography color="var(--dark)" variant="h3">
              {props.site?.name}
            </Typography>
          ) : null}
        </Breadcrumbs>

        {/* <TableApprovalStatus status="ownedAndLeasedOut" by="" /> */}
      </Box>
    </>
  );
};
